import TourQuantityBox from './TourQuantityBox';

export default TourQuantityBox;
